import { render, staticRenderFns } from "./Pending.vue?vue&type=template&id=968599da"
import script from "./Pending.js?vue&type=script&lang=js&external"
export * from "./Pending.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports